import React, { useState } from 'react';
import A from './A';

export default function Tabs({ tab, tabs, setTab }) {
    return <div className="Tabs">
        {tabs.map(t => <A key={t} className={tab == t ? 'selected tab' : 'tab'} onClick={()=>setTab(t)}>{t}</A>)}
    </div>
}